import { createFileRoute } from '@tanstack/react-router';

import { PpePage } from '@/features/safety/ppe-page';

export const Route = createFileRoute('/_app/projects/$projectId/safety/ppe')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <PpePage projectId={projectId} />;
}
